import { useGLTF } from '@react-three/drei';
import PropTypes from 'prop-types';

function SedeLimaCargo({ status }) {
  const { nodes, materials } = useGLTF('/models/SedeLimaCargo.gltf');
  const colorInactive = 'Grey';
  return (
    <group dispose={null} position={[13, -5, -4]} rotation={[0, 0.55, 0]}>
      <group position={[-3.25, 4.02, -4.72]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
        <mesh geometry={nodes.Cubo066.geometry} material={materials['blue title']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo066_1.geometry} material={materials['title center']} material-color={status === false ? colorInactive : null} />
      </group>
      <group position={[5.75, 3.94, -2.2]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
        <mesh geometry={nodes.Cubo063.geometry} material={materials['green hospital']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo063_1.geometry} material={materials['grey blind']} material-color={status === false ? colorInactive : null} />
      </group>
      <group position={[-0.83, 3.5, -4.32]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
        <mesh geometry={nodes.Cubo007.geometry} material={materials['grey blind']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo007_1.geometry} material={materials['green hospital']} material-color={status === false ? colorInactive : null} />
      </group>
      <group position={[-0.9, 3.5, -0.28]} rotation={[0, 1.57, 1.57]}>
        <mesh geometry={nodes.Cubo002.geometry} material={materials['grey blind.001']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo002_1.geometry} material={materials['green hospital']} material-color={status === false ? colorInactive : null} />
      </group>
      <group position={[-0.82, 5.43, -0.43]}>
        <mesh geometry={nodes.Cubo003.geometry} material={materials['green hospital.001']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo003_1.geometry} material={materials['green hospital']} material-color={status === false ? colorInactive : null} />
      </group>
      <group position={[4.8, 0.43, -4.14]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
        <mesh geometry={nodes.Cubo012.geometry} material={materials['green door']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo012_1.geometry} material={materials['blue title']} material-color={status === false ? colorInactive : null} />
        <mesh
          geometry={nodes.Cubo012_2.geometry}
          material={materials.yellow}
          material-color={status === false ? colorInactive : null}
        />
        <mesh geometry={nodes.Cubo012_3.geometry} material={materials['green hospital']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo012_4.geometry} material={materials['title center']} material-color={status === false ? colorInactive : null} />
      </group>
    </group>
  );
}

useGLTF.preload('/models/SedeLimaCargo.gltf');

export default SedeLimaCargo;

SedeLimaCargo.propTypes = {
  status: PropTypes.bool,
};

SedeLimaCargo.defaultProps = {
  status: true,
};
